<template>
  <div class="lazy-loading-component" v-bind:id="vueId">
    <slot v-if="isInViewPort || wasInViewPort"></slot>
  </div>
</template>


<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {v4 as uuidv4} from "uuid";
import {isDefined} from "@/utils";

@Options({})
export default class LazyLoadContainer extends Vue {

  private isInViewPort: boolean = false;
  private wasInViewPort:boolean = false;
  private readonly vueId: string ;

  constructor(props) {
    super(props);
    this.vueId = uuidv4();

    if (window.addEventListener) {
      addEventListener('DOMContentLoaded', this.onViewPortChange(), false);
      addEventListener('load', this.onViewPortChange(), false);
      addEventListener('scroll', this.onViewPortChange(), false);
      addEventListener('resize', this.onViewPortChange(), false);
    }
  }

  public mounted(): void {
    this.isInViewPort = this.isElementInViewport();
    this.wasInViewPort = this.isInViewPort;
  }

  public detectChanges() : void{
    this.onViewPortChange()();
  }

  private onViewPortChange(): () => void {
    return function () {
      this.isInViewPort = this.isElementInViewport();
      if(this.isInViewPort){
        this.wasInViewPort = true;
      }
    }.bind(this);
  }

  private isElementInViewport() {
    const el = document.getElementById(this.vueId);
    if (!isDefined(el)) {
      return false;
    }
    const rect = el.getBoundingClientRect();

    return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
  }

}
</script>

<style scoped>

</style>
